import { buildApiUrl, Type, sendPostRequest } from '@/api/api';
import { assertSchemaAndCoerce } from '@/shared/utils/schemas/assertions'
import { z } from 'zod'

export async function fetchTariffYears(ids: number[]) {
  const url = buildApiUrl(Type.TariffManagement, 'tariffs/years')
  const { data } = await sendPostRequest(url, { tariffIds: ids })
  return assertSchemaAndCoerce(data, z.array(z.number()))
}
